"use client";

import React, { createContext, useContext } from "react";
import type { Author, Post } from "@/payload-types";
import type { LocaleCode } from "@/lib/labels/types";
import type { ResolvedHeaderColors } from "@/features/theme/resolveBrandedStyle";

export interface AuthorDataContextValue {
    author: Author;
    posts: Post[];
    currentPage: number;
    totalPages: number;
    locale: LocaleCode;
    headerColors?: ResolvedHeaderColors;
}

const AuthorDataContext = createContext<AuthorDataContextValue | null>(null);

interface AuthorDataProviderProps {
    value: AuthorDataContextValue;
    children: React.ReactNode;
}

export function AuthorDataProvider({ value, children }: AuthorDataProviderProps) {
    return <AuthorDataContext.Provider value={value}>{children}</AuthorDataContext.Provider>;
}

export function useAuthorData(): AuthorDataContextValue {
    const ctx = useContext(AuthorDataContext);
    if (!ctx) {
        throw new Error("useAuthorData must be used within an AuthorDataProvider");
    }
    return ctx;
}
